import type { FieldConfig, FormData } from '@/types'

/**
 * Ambil nilai nested dari FormData berdasarkan path "a.b.c"
 */
export function getNestedValue (formData: FormData, key: string): unknown {
  return key
    .split('.')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((cur, k) => (cur as any)?.[k], formData)
}

/**
 * Hitung values & labels untuk slider berdasarkan config
 */
export function getRangeValues (field: FieldConfig, formData: FormData): {
  values: string[],
  labels: string[],
} {
  const defaultValues = ['oneToThree', 'fourToSix', 'sevenToNine', 'tenPlus']
  const defaultLabels = ['1-3', '4-6', '7-9', '10+']

  if (
    field.type === 'range' &&
    field.condition &&
    field.key.includes('.count')
  ) {
    const typeVal = getNestedValue(formData, field.condition.key) as string
    const freqKey = field.condition.key.replace(/\.type$/, '.frequency')
    const freqVal = getNestedValue(formData, freqKey) as string

    if (typeVal === 'regularly' && freqVal === 'weekly') {
      return { values: ['oneToThree', 'fourToSix'], labels: ['1-3', '4-6'] }
    }
  }

  return {
    values: field.rangeValues || defaultValues,
    labels: field.rangeLabels || defaultLabels,
  }
}

/**
 * Update CSS fill untuk track slider
 */
export function updateSliderFill (slider: HTMLInputElement): void {
  const pct = ((slider.valueAsNumber - +slider.min) / (+slider.max - +slider.min)) * 100
  slider.style.setProperty('--fill-percent', `${pct}%`)
}
